/* eslint-disable no-unused-expressions */
/* -------------------------------------------------------------------------- */
/*                                 Data Table                                 */
/* -------------------------------------------------------------------------- */
/* eslint-disable no-param-reassign */
const togglePaginationButtonDisable = (button, disabled) => {
  button.disabled = disabled;
  button.classList[disabled ? 'add' : 'remove']('disabled');
};

const listInit = () => {
  const { getData } = window.phoenix.utils;
  if (window.List) {
    const lists = document.querySelectorAll('[data-list]');

    if (lists.length) {
      lists.forEach(el => {
        let options = getData(el, 'list');

        if (options.pagination) {
          options = {
            ...options,
            pagination: {
              item: `<li><button class='page' type='button'></button></li>`,
              ...options.pagination
            }
          };
        }

        const paginationButtonFirst = el.querySelector(
          '[data-list-pagination="first"]'
        );
        const paginationButtonNext = el.querySelector(
          '[data-list-pagination="next"]'
        );
        const paginationButtonPrev = el.querySelector(
          '[data-list-pagination="prev"]'
        );
        const paginationButtonLast = el.querySelector(
          '[data-list-pagination="last"]'
        );
        const viewAll = el.querySelector('[data-list-view="*"]');
        const viewLess = el.querySelector('[data-list-view="less"]');
        const listInfo = el.querySelector('[data-list-info]');
        const listFilter = el.querySelector('[data-list-filter]');
        const pageInfo = el.querySelector('[data-list-page-info]');
        const pageSizeSelect = el.querySelector('[data-list-page-size]');

        // ---------------------------------------

        if (pageSizeSelect) {
          const v = localStorage.getItem(`${el.id}_page_size`);
          if (v) {
            options.page = Number(v);
            pageSizeSelect.value = v;
          }
        }

        // ---------------------------------------

        const list = new window.List(el, options);

        let totalItem = list.items.length;
        let itemsPerPage = list.page;
        const btnDropdownClose = list.listContainer.querySelector('.btn-close');
        let pageQuantity = Math.ceil(list.size() / list.page);
        let pageCount = 1;
        let numberOfcurrentItems =
          (pageCount - 1) * Number(list.page) + list.visibleItems.length;
        let isSearching = false;

        btnDropdownClose &&
          btnDropdownClose.addEventListener('search.close', () => {
            list.fuzzySearch('');
          });

        const updateListControls = () => {
          listInfo &&
            (listInfo.innerHTML = `${list.i} to ${numberOfcurrentItems} <span class='text-body-tertiary'> Items of </span>${totalItem}`);
          pageInfo && (pageInfo.innerHTML = pageIndex(pageCount, pageQuantity));

          paginationButtonFirst &&
            togglePaginationButtonDisable(
              paginationButtonFirst,
              pageQuantity === 0
            );
          paginationButtonPrev &&
            togglePaginationButtonDisable(
              paginationButtonPrev,
              pageCount === 1 || pageCount === 0
            );
          paginationButtonNext &&
            togglePaginationButtonDisable(
              paginationButtonNext,
              pageCount === pageQuantity || pageCount === 0
            );
          paginationButtonLast &&
            togglePaginationButtonDisable(
              paginationButtonLast,
              pageQuantity === 0
            );

          if (pageCount > 1 && pageCount < pageQuantity) {
            paginationButtonPrev &&
              togglePaginationButtonDisable(paginationButtonPrev, false);
            paginationButtonNext &&
              togglePaginationButtonDisable(paginationButtonNext, false);
          }
          if (pageQuantity > 0) {
            paginationButtonFirst &&
              togglePaginationButtonDisable(paginationButtonFirst, false);
            paginationButtonLast &&
              togglePaginationButtonDisable(paginationButtonLast, false);
          }
        };

        // List info
        updateListControls();

        if (paginationButtonFirst) {
          paginationButtonFirst.addEventListener('click', e => {
            e.preventDefault();
            pageCount = 1;
            list.show(1, itemsPerPage);
            e.currentTarget.blur();
          });
        }
        if (paginationButtonNext) {
          paginationButtonNext.addEventListener('click', e => {
            e.preventDefault();
            pageCount += 1;
            const nextItem = list.i + itemsPerPage;
            nextItem <= list.size() && list.show(nextItem, itemsPerPage);
            e.currentTarget.blur();
          });
        }
        if (paginationButtonPrev) {
          paginationButtonPrev.addEventListener('click', e => {
            e.preventDefault();
            pageCount -= 1;
            const prevItem = list.i - itemsPerPage;
            prevItem > 0 && list.show(prevItem, itemsPerPage);
            e.currentTarget.blur();
          });
        }
        if (paginationButtonLast) {
          paginationButtonLast.addEventListener('click', e => {
            e.preventDefault();
            pageCount = pageQuantity;
            const index = (pageCount - 1) * itemsPerPage + 1;
            list.show(index, itemsPerPage);
            e.currentTarget.blur();
          });
        }

        if (pageSizeSelect) {
          pageSizeSelect.addEventListener('change', () => {
            const newPageSize = Number(pageSizeSelect.value);
            localStorage.setItem(`${el.id}_page_size`, newPageSize);
            itemsPerPage = newPageSize;
            pageCount = 1;
            list.show(1, itemsPerPage);
            updateListControls();
          });
        }

        const toggleViewBtn = () => {
          viewLess.classList.toggle('d-none');
          viewAll.classList.toggle('d-none');
        };

        if (viewAll) {
          viewAll.addEventListener('click', () => {
            pageCount = 1;
            list.show(1, totalItem);
            toggleViewBtn();
          });
        }
        if (viewLess) {
          viewLess.addEventListener('click', () => {
            pageCount = 1;
            list.show(1, itemsPerPage);
            toggleViewBtn();
          });
        }
        // numbering pagination
        if (options.pagination) {
          el.querySelector('.pagination').addEventListener('click', e => {
            if (e.target.classList[0] === 'page') {
              const pageNum = Number(e.target.getAttribute('data-i'));
              if (pageNum) {
                list.show(itemsPerPage * (pageNum - 1) + 1, list.page);
                pageCount = pageNum;
              }
            }
          });
        }
        // filter
        if (options.filter) {
          const { key } = options.filter;
          listFilter.addEventListener('change', e => {
            list.filter(item => {
              if (e.target.value === '') {
                return true;
              }
              return item
                .values()
                [key].toLowerCase()
                .includes(e.target.value.toLowerCase());
            });
          });
        }

        list.on('searchStart', () => {
          isSearching = true;
        });
        list.on('searchComplete', () => {
          isSearching = false;
        });
        list.on('filterStart', () => {
          isSearching = true;
        });
        list.on('filterComplete', () => {
          isSearching = false;
        });

        list.on('updated', item => {
          if (!list.matchingItems.length) {
            pageQuantity = Math.ceil(list.size() / list.page);
          } else {
            pageQuantity = Math.ceil(list.matchingItems.length / list.page);
          }
          numberOfcurrentItems =
            (pageCount - 1) * Number(list.page) + list.visibleItems.length;
          updateListControls();

          // -------search-----------
          if (isSearching) {
            if (list.matchingItems.length === 0) {
              pageCount = 0;
            } else {
              pageCount = 1;
            }
            totalItem = list.matchingItems.length;
            numberOfcurrentItems =
              (pageCount === 0 ? 1 : pageCount - 1) * Number(list.page) +
              list.visibleItems.length;

            updateListControls();
            listInfo &&
              (listInfo.innerHTML = `${
                list.matchingItems.length === 0 ? 0 : list.i
              } to ${
                list.matchingItems.length === 0 ? 0 : numberOfcurrentItems
              } <span class='text-body-tertiary'> Items of </span>${
                list.matchingItems.length
              }`);
          }

          // -------fallback-----------
          const fallback =
            el.querySelector('.fallback') ||
            document.getElementById(options.fallback);

          if (fallback) {
            if (item.matchingItems.length === 0) {
              fallback.classList.remove('d-none');
            } else {
              fallback.classList.add('d-none');
            }
          }
        });

        if (window.listReadyCallback) {
          window.listReadyCallback(list);
        }
      });
    }
  }
};

export default listInit;
